function Navbar() {
  return (
    <header className="topbar">
      <a href="#home" className="brand">
        <span>Charmie’s</span> Kastle
      </a>

      <nav className="desktop-nav">
        <a href="#about">About</a>
        <a href="#products">Products</a>
        <a href="#shop">Shop</a>
        <a href="#contact">Contact</a>
      </nav>

      <a href="#contact" className="nav-cta">
        Order
      </a>
    </header>
  );
}

export default Navbar;